/**
 * A video kept in Assets, as the walk plays or shows it: its gated address and poster, each with a token minted
 * on this read, asked of the note once per video shown. Nothing until the note answers, or when it is not ready.
 */
import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { withToken } from "../../lib/noteUpload";

export interface NoteMedia {
  src: string | null;
  poster: string | null;
}

const NONE: NoteMedia = { src: null, poster: null };

export function useNoteMedia(noteId: string | null | undefined): NoteMedia {
  const [media, setMedia] = useState<{ id: string; m: NoteMedia } | null>(null);
  useEffect(() => {
    if (!noteId) return;
    let live = true;
    api.notes
      .get(noteId)
      .then((s) => {
        if (!live) return;
        setMedia({ id: noteId, m: s.ready ? { src: withToken(s.media_url, s.media_token), poster: withToken(s.poster_url, s.media_token) } : NONE });
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [noteId]);
  return media && media.id === noteId ? media.m : NONE;
}
